import $ from 'jquery'
import { initializeSwiperHero } from './product-swiper-hero'

/**
 * Initializes the color selection functionality for product hero image on the product page.
 *
 * This function sets up hover events to update the hero image and associated
 * violators based on the selected color swatch in the color container.
 */
export const initializeColorSelection = () => {
  const $colorContainer = $('.product-color-icons')
  // Photo books cover color options
  const $coverColorContainer = $('.product-cover-color-icons')

  const $prodHeroImgContainer = $('#prod-hero-img-container')
  const prodHeroImg = $prodHeroImgContainer.find(
    'responsive-image.prod-hero-img'
  )[0]!
  const $violator = $prodHeroImgContainer.find('responsive-image.violator')

  const selectColorUponHover = function ($colorContainer: JQuery<HTMLElement>) {
    const $colors = $colorContainer.find('.color')
    const $originalSwatch = $colorContainer.find('.color.selected')
    const originalItemId = $originalSwatch.data('itemid')

    $colors.hover(
      function () {
        const $a = $(this)
        const itemId = $a.data('itemid')

        $colors.removeClass('selected')
        $a.addClass('selected')

        update(itemId)
      },
      function () {
        $colors.removeClass('selected')
        $originalSwatch.addClass('selected')

        update(originalItemId)
      }
    )
  }

  const update = function (itemId: number) {
    const productSwiperHero = initializeSwiperHero()
    // Switching colors might switch the non-default image to the default image, which feels weird.
    // Force the hero image to go to the default image before switching colors.
    if (productSwiperHero) {
      productSwiperHero.slideTo(0)
    }

    const data =
      window.pcRelatedProductsData != null
        ? window.pcRelatedProductsData[itemId]
        : undefined
    if (data) {
      if (data.hugeImageUrl) {
        prodHeroImg.setAttribute('src', data.hugeImageUrl)
      }
      if (data.foilColor) {
        $violator
          .toArray()
          .forEach((el) =>
            el.setAttribute(
              'src',
              `/img/FoilViolators/20211007/foil-${data.foilColor!.toLowerCase()}_product-page.png`
            )
          )
      }
    }
  }

  selectColorUponHover($colorContainer)
  selectColorUponHover($coverColorContainer)
}
